/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

(function () {
  const pushToDataLayer = window.BAO.Utils.pushToDataLayer

  const config = {
    navAccount: document.querySelector('[data-account-drawer]'),
    bodyClass: document.querySelector('body'),
    closeSidePanelButton: document.querySelector('[data-account-drawer-close]'),
    recoverPasswordForm: document.querySelector('#RecoverPassword'),
    requestUser: document.querySelector('#RequestUser'),
    hideRecoverPasswordLink: document.querySelector('#HideRecoverPasswordLink'),
    customerLoginForm: document.querySelector('#HideRecoverPasswordLink'),
    wholesaleLoginForm: document.querySelector('.wholesale-login__form'),
    wholesaleRequestUser: document.querySelector('.wholesale-request-user'),
    resetSuccess: document.querySelector('#ResetSuccess'),
  }

  if (!config.navAccount) return

  if (config.navAccount.parentElement !== document.body) {
    document.body.appendChild(config.navAccount)
  }

  const openToggles = document.querySelectorAll('[data-account-drawer-toggle]')

  const openLoginForm = function (evt) {
    if (evt) evt.preventDefault()

    const fostrMobilemenu = document.querySelector('fostr-mobilemenu')
    if (fostrMobilemenu && typeof fostrMobilemenu.mobilemenuHide === 'function') {
      fostrMobilemenu.mobilemenuHide()
    }

    config.navAccount.showModal()
    config.navAccount.setAttribute('aria-hidden', 'false')
    config.bodyClass.classList.add('overflow-hidden', 'login-sidebar--open')
    handleAccountTriggerTracking(evt)

    requestAnimationFrame(() => config.navAccount.classList.add('is-active'))

    if (config.closeSidePanelButton) config.closeSidePanelButton.focus()
  }

  const closeLoginForm = function () {
    if (!config.navAccount.open) return

    config.navAccount.classList.remove('is-active')
    config.navAccount.setAttribute('aria-hidden', 'true')
    config.bodyClass.classList.remove('overflow-hidden', 'login-sidebar--open')

    config.navAccount.addEventListener(
      'transitionend',
      () => config.navAccount.close(),
      { once: true }
    )
  }

  openToggles.forEach(toggle => {
    toggle.addEventListener('click', openLoginForm)
  })

  if (config.closeSidePanelButton) {
    config.closeSidePanelButton.addEventListener('click', closeLoginForm)
  }

  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape' && config.navAccount.getAttribute('aria-hidden') === 'false') {
      closeLoginForm()
    }
  })

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-gtm-el="account-drawer"]')) {
      handleAccountDrawerTracking(event)
    }
  })

  config.navAccount.addEventListener('click', (event) => {
    if (event.target === config.navAccount) {
      closeLoginForm()
    }
  })

  config.navAccount.addEventListener('cancel', (event) => {
    event.preventDefault()
    closeLoginForm()
  })

  if (window.BAO && window.BAO.eventBus) {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.LOG_IN,
      openLoginForm,
    )
  }

  if (!config.recoverPasswordForm || !config.requestUser || !config.hideRecoverPasswordLink) {
    return
  }

  checkUrlHash()
  resetPasswordSuccess()

  config.recoverPasswordForm.addEventListener('click', onShowHidePasswordForm)
  config.requestUser.addEventListener('click', onShowRequestForm)
  config.hideRecoverPasswordLink.addEventListener('click', onShowHidePasswordForm)

  function onShowHidePasswordForm (evt) {
    evt.preventDefault()
    toggleRecoverPasswordForm()
  }

  function onShowRequestForm (evt) {
    evt.preventDefault()
    toggleRequestUserForm()
  }

  function checkUrlHash () {
    const hash = window.location.hash

    if (hash === '#recover') {
      toggleRecoverPasswordForm()
    }

    if (hash === '#request' || hash === '#contact_form') {
      toggleRequestUserForm()
    }
  }

  function toggleRecoverPasswordForm () {
    if (!config.customerLoginForm) return
    config.recoverPasswordForm.classList.toggle('hide')
    config.customerLoginForm.classList.toggle('hide')
  }

  function toggleRequestUserForm () {
    if (!config.wholesaleLoginForm || !config.wholesaleRequestUser) return
    config.wholesaleLoginForm.classList.toggle('hide')
    config.wholesaleRequestUser.classList.toggle('hide')
  }

  function resetPasswordSuccess () {
    const formState = document.querySelector('.reset-password-success')
    if (!formState || !config.resetSuccess) return

    config.resetSuccess.classList.remove('hide')
  }

  function handleAccountTriggerTracking (evt) {
    const eventContextElement = evt.target.closest('[data-customer-logged-in]')
    const eventContext = eventContextElement ? eventContextElement.dataset.customerLoggedIn : null

    const parameters = {
      target_context: evt.target.closest('fostr-mobilemenu-tier') ? 'mobile_menu' : 'desktop',
      event_context: eventContext
    }

    pushToDataLayer('account_drawer_trigger', parameters)
  }

  function handleAccountDrawerTracking (evt) {
    const targetContext = evt.target.closest('[data-gtm-target-context]')

    if (!targetContext) return

    switch (targetContext.dataset.gtmTargetContext) {
      case 'account-drawer-menu':
        trackAccountDrawerMenu(evt)
        break;
      case 'account-drawer-wishlist':
        trackAccountDrawerWishlist(evt)
        break;
      case 'account-drawer-campaigns':
        trackAccountDrawerCampaigns(evt)
        break;
      case 'account-drawer-logout':
        pushToDataLayer('account_drawer_logout_click')
        break;
      case 'account-drawer-close':
        pushToDataLayer('account_drawer_close')
        break;
      default:
        break;
    }
  }

  function trackAccountDrawerMenu (evt) {
    const menuItem = evt.target.closest('a')

    if (!menuItem) return

    const parameters = {
      target_text: menuItem.innerText,
    }

    pushToDataLayer('account_drawer_menu_click', parameters)
  }

  function trackAccountDrawerWishlist (evt) {
    const productCard = evt.target.closest('product-card')
    const wishlistFooterButton = evt.target.closest('[data-gtm-el="account-drawer-edit-wishlist"]')

    if (!productCard && !wishlistFooterButton) return

    const parameters = {
      item_title: productCard?.dataset.productTitle || 'n/a',
      target_element: wishlistFooterButton ? 'edit_wishlist_button' : 'product_card'
    }

    pushToDataLayer('account_drawer_wishlist_click', parameters)
  }

  function trackAccountDrawerCampaigns (evt) {
    const campaignItem = evt.target.closest('a')

    if (!campaignItem) return

    const parameters = {
      item_title: campaignItem.dataset.gtmItemTitle,
    }

    pushToDataLayer('account_drawer_campaigns_click', parameters)
  }
})()
